import {Component, Input, OnInit} from '@angular/core';
import {Platform} from '@angular/cdk/platform';

@Component({
    selector: 'documents-listing-tablet',
    templateUrl: './documents-listing-tablet.component.html',
    styleUrls: ['./documents-listing-tablet.component.scss']
})
export class DocumentsListingTabletComponent implements OnInit {

    @Input() statementAndDocuments: any;
    @Input() isStatementDocument = false;

    @Input() isBookingDocument = false;
    @Input() bookingDocuments: any;

    constructor(public platform: Platform) {
    }

    ngOnInit(): void {
    }

    getColoredBookingStatus(status: any) {
        switch (status) {
            case 'Arrived':
                return 'tertiary-bgcolor';
            case 'In Progress':
                return 'in-progress';
            case 'Delivered':
                return 'delivered';
            case 'Planned':
                return 'planned';
            case 'Confirmed':
                return 'confirmed';
            case 'Booking Created':
                return 'booking-created';
            case 'Completed':
                return 'planned';
            case 'Customs Cleared':
                return 'in-progress';
            case 'Stuffed':
                return 'tertiary-bgcolor';
            case 'Carted':
                return 'tertiary-bgcolor';
            case 'Departed':
                return 'delivered';
            case 'Sailed':
                return 'planned';
            case 'Document Received':
                return 'confirmed';
            case 'Truck Placed':
                return 'tertiary-bgcolor';
            case 'Truck Dispatched':
                return 'in-progress';
            case 'Initiated':
                return 'planned';
            case 'Cancelled':
                return 'blue-bgcolor';
        }
    }

    getColourStatus(shipmentInvoiceType: any) {
        switch (shipmentInvoiceType) {
            case 'AIR':
                return 'shipment-type-air';
            case 'LCL':
                return 'shipment-type-lcl';
            case 'FCL':
                return 'p-text-success';
            case 'Transport':
                return 'p-text-warning';
            case 'Service Job':
                return 'shipment-type-sj';
            case 'Clearance':
                return 'shipment-type-cc';
        }
    }

}
